import * as DialogPrimitive from "@radix-ui/react-dialog";

import { cn } from "@/lib/utils";

export interface LightboxProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  src: string;
  alt: string;
}

function Lightbox({ open, onOpenChange, src, alt }: LightboxProps) {
  return (
    <DialogPrimitive.Root open={open} onOpenChange={onOpenChange}>
      <DialogPrimitive.Portal>
        <DialogPrimitive.Overlay
          className={cn(
            "fixed inset-0 z-50 bg-black/80",
            "data-[state=open]:animate-in data-[state=closed]:animate-out",
            "data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0"
          )}
        />
        <DialogPrimitive.Content
          className={cn(
            "fixed inset-0 z-50 flex items-center justify-center",
            "focus:outline-none"
          )}
          aria-label={alt || "Image preview"}
          aria-describedby={undefined}
          onClick={(e) => {
            // Close when clicking the backdrop area (not the image itself)
            if (e.target === e.currentTarget) {
              onOpenChange(false);
            }
          }}
        >
          {/* Visually-hidden title for accessibility (required by Radix Dialog) */}
          <DialogPrimitive.Title className="sr-only">
            {alt || "Image preview"}
          </DialogPrimitive.Title>
          <img
            src={src}
            alt={alt}
            className="max-h-[90vh] max-w-[90vw] object-contain"
          />
        </DialogPrimitive.Content>
      </DialogPrimitive.Portal>
    </DialogPrimitive.Root>
  );
}

Lightbox.displayName = "Lightbox";

export { Lightbox };
